import { render, staticRenderFns } from "./DiffViewer.vue?vue&type=template&id=cb7b9c7c&scoped=true"
import script from "./DiffViewer.vue?vue&type=script&lang=js"
export * from "./DiffViewer.vue?vue&type=script&lang=js"
import style0 from "./DiffViewer.vue?vue&type=style&index=0&id=cb7b9c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7b9c7c",
  null
  
)

export default component.exports